/*
 * @Author: Han
 * @Date: 2021-11-30 18:07:54
 * @LastEditors: Han
 * @LastEditTime: 2021-12-14 10:34:11
 * @FilePath: \console\console\src\http\moudules\informationMaintenance.js
 */
import axios from '../axios'

// 教育局

// 全部教育局列表
export const getAllEduList = () => {
  return axios({
    url: '/education/list',
    method: 'GET'
  })
}
// 分页获取教育局
export const getEduListInfo = (data) => {
  return axios({
    url: '/education/select',
    method: 'GET',
    data
  })
}
// 新增教育局信息
export const saveEducation = (data) => {
  return axios({
    url: '/education/save',
    method: 'POST',
    data
  })
}
// 修改教育局信息
export const updateEducation = (data) => {
  return axios({
    url: '/education/update',
    method: 'POST',
    data
  })
}
// 教育局状态启用停止
export const switchEducation = (data) => {
  return axios({
    url: '/education/switch',
    method: 'POST',
    data
  })
}

///分页筛选
export const thirdpartyPage = (data) => {
  return axios({
    url: '/third_party/page',
    method: 'GET',
    data
  })
}
//更新第三方机构
export const thirdpartyUpdata = (data) => {
  return axios({
    url: '/third_party/update',
    method: 'POST',
    data
  })
}
//新增第三方机构
export const thirdpartyInsert = (data) => {
  return axios({
    url: '/third_party/insert',
    method: 'POST',
    data
  })
}
//新增第三方机构
export const thirdpartyList = (data) => {
  return axios({
    url: '/third_party/list',
    method: 'GET',
    data
  })
}
//绑定第三方机构
export const thirdpartyBind = (data) => {
  return axios({
    url: '/third_party/bind_existed',
    method: 'POST',
    data
  })
}
//禁用或启用第三方机构
export const thirdpartyDisable = (data) => {
  return axios({
    url: '/third_party/enable_or_disable',
    method: 'POST',
    data
  })
}

//查询列表--机构教师
export const listThirdPartyUser = (data) => {
  return axios({
    url: '/con/account/listThirdPartyUser',
    method: 'GET',
    data
  })
}

//修改用户状态--机构教师
export const updateThirdPartyUserStatus = (data) => {
  return axios({
    url: '/con/account/updateThirdPartyUserStatus',
    method: 'GET',
    data
  })
}
//添加教师--机构教师
export const createThirdPartyUser = (data) => {
  return axios({
    url: '/con/account/createThirdPartyUser',
    method: 'POST',
    data
  })
}

//添加教师--机构教师
export const updateThirdPartyUser = (data) => {
  return axios({
    url: '/con/account/updateThirdPartyUser',
    method: 'POST',
    data
  })
}





// 学校

// 根据教育局分页获取学校
export const getSchoolListInfo = (data) => {
  return axios({
    url: '/school/select',
    method: 'GET',
    data
  })
}
// 解绑学校
export const unBindSchool = (data) => {
  return axios({
    url: '/school/unBind',
    method: 'POST',
    data
  })
}
// 禁用学校
export const switchSchool = (data) => {
  return axios({
    url: '/school/switch',
    method: 'POST',
    data
  })
}
// 未绑定学校列表
export const getSchoolUnBind = (data) => {
  return axios({
    url: '/school/selectUnBind',
    method: 'GET',
    data
  })
}
// 绑定学校到教育局
export const bindSchoolUn = (data) => {
  return axios({
    url: '/school/bind',
    method: 'POST',
    data
  })
}
// 新增学校
export const addSchool = (data) => {
  return axios({
    url: '/school/save',
    method: 'POST',
    data
  })
}
// 更新学校信息
export const updateSchool = (data) => {
  return axios({
    url: '/school/update',
    method: 'POST',
    data
  })
}






// 用户

// 获取用户列表
export const getUserList = (data) => {
  return axios({
    url: '/con/account/listUser',
    method: 'GET',
    data
  })
}
// 添加用户
export const addUser = (data) => {
  return axios({
    url: '/con/account/createUser',
    method: 'GET',
    data
  })
}
// 更新用户
export const updateUser = (data) => {
  return axios({
    url: '/con/account/updateUser',
    method: 'GET',
    data
  })
}
// 禁用用户
export const setUserStatus = (data) => {
  return axios({
    url: '/con/account/updateUserStatus',
    method: 'GET',
    data
  })
}
// 用户帐号校验
export const checkMobil = (data) => {
  return axios({
    url: '/con/account/checkMobile',
    method: 'GET',
    data
  })
}






// WEBPACK FOOTER //
// ./src/http/moudules/informationMaintenance.js